export default __webpack_public_path__ + "static/media/prev-Multi-GNSS-Modules-3.42a6d4d5.png";